export default {
    campaign: null,
    space: null,
    plugin: null,
    user: null,
    apiParams: {},
};
